export const RQ_GET_ALL_BILLS_API = {
  url: 'api/bills/all',
  method: 'GET',
  auth: true,
};

export const RQ_GET_BILL_BY_ID_API = {
  url: 'api/bills/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_CREATE_BILL_API = {
  url: 'api/bills/create',
  method: 'POST', 
  auth: true,
};

export const RQ_DELETE_BILL_API = {
  url: 'api/bills/<%= id %>',
  method: 'DELETE',
  auth: true,
};

export const RQ_UPDATE_BILL_API = {
  url: 'api/bills/<%= id %>/update',
  method: 'PUT',
  auth: true,
};

export const RQ_UPDATE_PAYMENT = {
  url: 'api/bills/<%= billId %>/payment',
  method: 'POST',
  auth: true,
};

export const RQ_BILL_LOOKUP_BYFILTER_API = {
  url: 'api/billing/lookup/byfilter',
  method: 'POST',
  auth: true,
};

export const RQ_GET_DELETED_BILLS_API = {
  url: 'api/bills/deleted',
  method: 'GET',
  auth: true,
};

export const RQ_RESTORE_BILL_API = {
  url: 'api/bills/<%= id %>/restore',
  method: 'PUT',
  auth: true,
};

export const RQ_BILL_DASHBOARD_API = {
  url: 'api/bills/dashboard',
  method: 'POST',
  auth: true,
};

export const RQ_PERMANENT_DELETE_BILL_API = {
  url: 'api/bills/<%= id %>/permanent',
  method: 'DELETE',
  auth: true,
};
